import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
interface GSAContractHolderLogoProps {
  className?: string;
  variant?: "contained" | "transparent";
}
export const GSAContractHolderLogo = t0 => {
  const $ = _c(8);
  const {
    className,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "contained" : t1;
  const t2 = variant === "contained" && "bg-white rounded-lg px-3 py-1.5 shadow-sm border border-white/10";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("inline-flex items-center gap-3 select-none", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative flex shrink-0 items-center justify-center"><svg width="48" height="48" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-12 w-12"><rect width="100" height="100" fill="#00467F" /><text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fill="white" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fontSize="38" letterSpacing="-1">GSA</text><path d="M20 15 L22 21 H28 L23 25 L25 31 L20 27 L15 31 L17 25 L12 21 H18 Z" fill="white" /></svg></div>;
    t5 = <div className="h-9 w-px bg-gray-300" />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col"><span className="text-aq-gsa-blue font-bold text-sm tracking-wider leading-tight">Contract</span><span className="text-aq-gsa-blue font-bold text-sm tracking-wider leading-tight">Holder</span></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3) {
    t7 = <div className={t3} aria-label="GSA Contract Holder Logo">{t4}{t5}{t6}</div>;
    $[6] = t3;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};